import { Button } from '@mui/material';
import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Oval } from 'react-loader-spinner';
import { useSelector } from 'react-redux';

import { useAppDispatch } from 'store/store';
import { deleteTicket, getTicketsByUserId } from 'store/ticket-service/asyncActions';
import { getTicketUpdating, getTickets } from 'store/ticket-service/selector';
import { setActiveTicket, setSidebarView } from 'store/ticket-service/ticketSlice';

import { NamespacesList } from 'core/enums/common';

import { InfoModal } from 'components/shared/Modal/Info';

import { ReactComponent as Error } from 'assets/icons/error.svg';

type DeleteRequestModalProps = {
	handleCloseModal: () => void;
	ticketId?: string;
	userId: string;
};

export const DeleteTicketModal: FC<DeleteRequestModalProps> = ({
	handleCloseModal,
	ticketId,
	userId,
}) => {
	const { t: modalTranslate } = useTranslation(NamespacesList['modals']);

	const dispatch = useAppDispatch();
	const updating = useSelector(getTicketUpdating);
	const tickets = useSelector(getTickets);

	const [open, setOpen] = useState<boolean>(true);

	const handleClose = () => {
		handleCloseModal();
		setOpen(false);
	};

	const handleDelete = () => {
		const recordsPerPage = tickets.length;

		//@ts-ignore
		dispatch(deleteTicket(ticketId))
			.then(() => handleCloseModal())
			.then(() => dispatch(getTicketsByUserId({ userId: userId, recordsPerPage })))
			.then((res: any) => {
				dispatch(setActiveTicket(res.payload.data[0]));
				dispatch(setSidebarView(true));
			});
	};
	return (
		<InfoModal
			isOpen={open}
			onClose={handleClose}
			image={<Error />}
			title={modalTranslate('deleteTicketModal.title')}
			description={modalTranslate('deleteTicketModal.description')}
			buttons={
				<>
					{updating ? (
						<Button
							sx={{
								height: '44px',
								width: { xs: '49%', sm: '215px' },
								borderRadius: '8px',
								marginTop: '24px',
							}}
							variant="outlined"
							color="error"
							disabled={updating}
						>
							<Oval
								height={24}
								width={24}
								color="rgba(0, 0, 0, 0.12)"
								wrapperStyle={{}}
								wrapperClass=""
								visible={true}
								ariaLabel="oval-loading"
								secondaryColor="rgba(0, 0, 0, 0.12)"
								strokeWidth={5}
								strokeWidthSecondary={5}
							/>
						</Button>
					) : (
						<Button
							sx={{
								height: '44px',
								width: { xs: '49%', sm: '215px' },
								borderRadius: '8px',
								textTransform: 'none',
								fontSize: '16px',
								fontWeight: '700',
								marginTop: '24px',
							}}
							variant="outlined"
							color="error"
							onClick={handleDelete}
						>
							{modalTranslate('deleteTicketModal.confirm')}
						</Button>
					)}

					<Button
						sx={{
							height: '44px',
							width: { xs: '49%', sm: '215px' },
							borderRadius: '8px',
							textTransform: 'none',
							fontSize: '16px',
							fontWeight: '700',
							marginTop: '24px',
						}}
						variant="contained"
						color="error"
						onClick={handleCloseModal}
					>
						{modalTranslate('deleteTicketModal.cancel')}
					</Button>
				</>
			}
		></InfoModal>
	);
};
